import { Attribute, AttributePropertyValues, IAttribute } from "../System.Runtime/Attribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareEntityIdAttributePropertyValues =
    AttributePropertyValues
    & {
        entityDescriptionProperty: string;
        entityName: string;
        entityNameFriendly: string;
        entityNamePlural: string;
        entityNamePluralFriendly: string;
        foreignEntityAlias: string;
        entityFilter: string;
    };

export type ClientAwareEntityIdAttributeProperties = {
    [name in keyof ClientAwareEntityIdAttributePropertyValues]?: ClientAwareEntityIdAttributePropertyValues[name];
};

export interface IClientAwareEntityIdAttribute extends IAttribute, ClientAwareEntityIdAttributeProperties
{
}

export class ClientAwareEntityIdAttribute extends Attribute implements IClientAwareEntityIdAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareEntityIdAttribute";
    public static override className = "ClientAwareEntityIdAttribute";

    public entityDescriptionProperty?: string;
    public entityName?: string;
    public entityNameFriendly?: string;
    public entityNamePlural?: string;
    public entityNamePluralFriendly?: string;
    public foreignEntityAlias?: string;
    public entityFilter?: string;

    constructor(propertyValues?: Partial<ClientAwareEntityIdAttributePropertyValues>)
    {
        super(propertyValues);

        this.entityDescriptionProperty = propertyValues?.entityDescriptionProperty;
        this.entityName = propertyValues?.entityName;
        this.entityNameFriendly = propertyValues?.entityNameFriendly;
        this.entityNamePlural = propertyValues?.entityNamePlural;
        this.entityNamePluralFriendly = propertyValues?.entityNamePluralFriendly;
        this.foreignEntityAlias = propertyValues?.foreignEntityAlias;
        this.entityFilter = propertyValues?.entityFilter;
    }
}